import React from "react";
import { Link } from "react-router-dom";
import DropDownAboutUs from "../NavComp/DropDownAboutUs";
import DropDownAdmissions from "../NavComp/DropDownAdmissions";
import DropDownAcademics from "../NavComp/DropDownAcademics";
import DropDownTheSchool from "../NavComp/DropDownTheSchool";

const baseURL = process.env.PUBLIC_URL + '/assets/';

const NavBar = () => {
  return (
    <div className="fixed top-0 w-full px-11 py-4 z-20 bg-footer-blue-custom flex justify-between items-center">
      <div className=" flex items-center gap-7">
        <Link to="/">
          <img
            className="w-20 h-20 rounded-full border-1 border-black"
            src={`${baseURL}/Logo.jpg`}         
            alt="Logo"
          />
        </Link>
        <div className="text-neutral-100  text-2xl font-bold font-'DM Sans' capitalize tracking-wide">
          <Link to="/">Motherland Children Academy </Link>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="flex gap-5 justify-between tracking-wider  whitespace-nowrap text-neutral-100">
          <div className="grow justify-center px-2 py-3 text-sm font-semibold mb-1 text-center rounded-xl bg-zinc-800">
            <Link to="/Mpd">Mandatory Public Disclosure</Link>
          </div>
          <div className="grow justify-center px-2 py-3 text-center font-semibold mb-1 text-sm rounded-xl bg-zinc-800">
           <Link to="/AdmissionEnquiryPage"> Admission Enquiry</Link>
          </div>
        </div>
        <div className="flex items-center gap-10 mt-3">
          <DropDownTheSchool />
          <DropDownAboutUs />
          <DropDownAdmissions />
          <DropDownAcademics />
          {/* <NavLink text="Contact" /> */}
        </div>
      </div>
    </div>
  );
};

const NavLink = ({ text }) => (
  <div className="text-amber-300 text-lg font-normal font-'DM Sans' capitalize tracking-wide hover:text-amber-500 cursor-pointer">
    {text}
  </div>
);

export default NavBar;
